import React from "react";
import { IconButton } from "@mui/material";
import CodeIcon from "@mui/icons-material/Code";
import CustomTooltip from "src/components/custom-tooltip";

const EmbeddedButton = ({ handleClick, isProfilePrivate }) => {
    return (
        <CustomTooltip
            title={
                isProfilePrivate
                    ? "You profile is private. Enable via  your account settings"
                    : "Embedded Code"
            }
        >
            <div>
                <IconButton
                    onClick={handleClick}
                    aria-label="delete"
                    size="small"
                    disabled={isProfilePrivate}
                >
                    <CodeIcon fontSize="small" />
                </IconButton>
            </div>
        </CustomTooltip>
    );
};

export default EmbeddedButton;
